import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import { TYPE_LABELS, formatViews } from '@/utils/movie';

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 丝瓜视频`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-accent-500/95 px-2 py-0.5 font-label text-xs font-bold text-background-50">
          <i className="ri-star-fill text-xs" />
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-foreground-950/60 px-2 py-0.5 font-label text-xs font-medium text-background-50">
          {TYPE_LABELS[movie.type]}
        </span>
        {typeof rank === 'number' && (
          <span
            className={`absolute bottom-2 left-2 flex h-7 w-7 items-center justify-center rounded-md font-heading text-sm font-bold ${
              rank <= 3 ? 'bg-accent-500 text-background-50' : 'bg-foreground-950/70 text-background-50'
            }`}
          >
            {rank}
          </span>
        )}
        <span className="absolute bottom-2 right-2 hidden items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50 group-hover:flex">
          <i className="ri-play-fill" /> {formatViews(movie.views)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="line-clamp-1 font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
          {movie.year} · {movie.region} · {movie.genres.slice(0, 2).join(' / ')}
        </p>
      </div>
    </Link>
  );
}